<script lang="ts" setup>
import type { TruckType } from "@/api/trucks/dto/truck.dto";
import { TruckTypeList } from "@/constants/truck";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const model = defineModel<TruckType | TruckType[]>();

const props = withDefaults(
  defineProps<{
    rules?: any[];
    label?: string;
    disabled?: boolean;
    multiple?: boolean;
  }>(),
  {
    rules: () => [],
    label: "",
    disabled: false,
    multiple: false,
  },
);
</script>

<template>
  <v-select
    id="truck_type"
    v-model="model"
    :disabled="props.disabled"
    :items="TruckTypeList"
    :label="props.label || t('trucks.truck-type')"
    :multiple="props.multiple"
    :rules="props.rules"
    autocomplete="off"
    class="mb-0 width-100"
    color="primary"
    density="compact"
    hide-details="auto"
    item-title="name"
    item-value="id"
    variant="outlined"
  />
</template>
